import { type ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { casePageMeta } from "@/lib/casePages";
import { usePageMeta } from "@/lib/pageMeta";

/* The title and the description of a case study, for the browser tab, a search
   result and a shared link. Set here and not in the page, so the short and the
   full version of a case study share them. The four SkillLab pages stay out
   of search engines (noindex in the pages themselves). */
export function CaseMeta({ path, children }: { path: string; children: ReactNode }) {
  usePageMeta({ ...casePageMeta(path), type: "article" });
  return <>{children}</>;
}

/* An address that changed. What follows it comes along ("?view=short", a
   place in the page), so a link Lorenzo sent before still opens what it meant. */
export function Moved({ to }: { to: string }) {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: to, search, hash }} replace />;
}
